import { IconDownload } from './IconDownload';

export function IconUpload({ className }: { className?: string }) {
  return <IconDownload className={className} rotate />;
}
